import { SailingPerformance } from '@didi/sailing-data-tools'
import { getSodaGlobalParams } from '@/common/utils/bridge'
const { version } = require('../package.json')

export async function initPerformanceTool (router) {
  let globalParams = {}
  try {
    globalParams = await getSodaGlobalParams()
  } catch (e) {
    // console.warn('can\'t find getSodaGlobalParams')
  }
  let appVersion = globalParams.appVersion
  // 初始化
  new SailingPerformance({
    env: process.env.NODE_ENV,
    Omega: window.Omega,
    prefix: 'soda-bd-i18n',
    attrs: {
      version: version,
      app_version: appVersion
    },
    router,
  })
}